import { is } from 'stdlib/is'
import { RX } from 'stdlib/RX'

/** Vulkant használó GPU-k regexpjei. */
const VULKAN_GPUS = [
  /Mali-G5\d+/i,
  /Mali-G6\d+/i,
  /Mali-G7\d+/i,
  /Xclipse \d+/i
] as const

const ADRENO_GPU_REGEX = /Adreno\D*\d+/i

/**
 * Milyen módban fusson a ContentScale?
 * @param gpuRenderer - A GPU renderer információja.
 * @param browserName - A futtató böngésző.
 */
export default function getScaleMode (
  gpuRenderer: string | null,
  browserName: string
): 'translate' | 'zoom' {
  const isAdrenoGPU = RX.test(ADRENO_GPU_REGEX, gpuRenderer ?? '')

  const lowerBrowserName = browserName.toLowerCase()

  // Speciális eset: Adreno GPU-k Chrome alatt.
  // Samsung SM-T500 alatt produkálta a hibát.
  // Az os-t Linuxnak érzékelte, de a gpuRendererben szerepelt
  // az openGl szó, ami miatt translate módra állt be,
  // viszont a renderelés hibás volt. [zlt] 2025.12.22.
  if (isAdrenoGPU && lowerBrowserName === 'chrome') {
    return 'zoom'
  }

  const lowerRenderer = gpuRenderer?.toLowerCase() ?? ''

  if (
    // A Direct3D része a DirectX-nek, ez a Windows saját, hivatalos grafikus API-ja.
    lowerRenderer.includes('direct3d') ||
    // Linux
    lowerRenderer.includes('opengl') ||
    // Apple
    lowerRenderer.includes('metal')
  ) {
    return 'translate'
  }

  if (lowerRenderer.includes('vulkan')) {
    return 'zoom'
  }

  if (gpuRenderer) {
    const isVulkanGPU = VULKAN_GPUS.some((regex) => RX.test(regex, gpuRenderer))

    if (isVulkanGPU) {
      return 'zoom'
    }
  }

  // Ha valami oknál fogva nem tudjuk a renderer információkat, akkor browser fallback.
  if (is.null(gpuRenderer) && lowerBrowserName === 'chrome') {
    return 'zoom'
  }

  return 'translate'
}
